export enum XmType {    
    ScreeningXm = 1,
    ExploratoryXm = 2,
    FinalXm = 3
}